import '../styles/ChatBubble.css'

function ChatBubble({ username, message }) {
  // Escape HTML to prevent XSS
  const escapeHtml = (text) => {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }

  const truncated = message.length > 140 ? message.slice(0, 140) + '…' : message

  return (
    <div className="chat-bubble">
      <div className="chat-bubble-username">{username}</div>
      <div
        className="chat-bubble-message"
        dangerouslySetInnerHTML={{ __html: escapeHtml(truncated) }}
      />
    </div>
  )
}

export default ChatBubble